// extracted by mini-css-extract-plugin
export default {"component":"TabButtonsContainer_component__HPCD9","dark":"TabButtonsContainer_dark__sSlVp"};